import React, { useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf';
import '../../styles/user/PdfPreviewModal.css';

const PdfPreviewModal = ({ fileUrl, onClose }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const isPdf = fileUrl?.toLowerCase().endsWith('.pdf');

  useEffect(() => {
    setPageNumber(1);
    setNumPages(null);
  }, [fileUrl]);

  if (!fileUrl) return null;

  return (
    <div className="pdf-modal-overlay">
      <div className="pdf-modal">
        <button className="pdf-close" onClick={onClose}>✕</button>

        {isPdf ? (
          <>
            <Document
              file={fileUrl}
              onLoadSuccess={({ numPages }) => setNumPages(numPages)}
              loading="Loading PDF..."
              error="Failed to load PDF"
            >
              <Page
                pageNumber={pageNumber}
                width={600}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </Document>

            {numPages > 1 && (
              <div className="pdf-controls">
                <button
                  disabled={pageNumber === 1}
                  onClick={() => setPageNumber(p => p - 1)}
                >
                  ‹
                </button>

                <span>{pageNumber} / {numPages}</span>

                <button
                  disabled={pageNumber === numPages}
                  onClick={() => setPageNumber(p => p + 1)}
                >
                  ›
                </button>
              </div>
            )}
          </>
        ) : (
          <img
            src={fileUrl}
            alt="Preview"
            className="image-preview"
          />
        )}
      </div>
    </div>
  );
};

export default PdfPreviewModal;